export default {
  modifierData: {
    items: [], _links: {}, _meta: {}
  },
  modifierList: []
}
